import { Box } from "@mui/material";
import { AnonymousLayout } from "Components/Layout/AnonymousLayout";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { BankRatingDetail } from "Components/Shared/BanksList/BankButton/Components/BankRatingDetail/BankRatingDetail";
import type { Bank } from "Infrastructure/Api/Api";
import { useParams } from "react-router-dom";
import { Resources, useResource } from "Translations/Resources";
import { PageTitle } from "Components/Shared/PageTitles/PageTitle";
import { appUrl } from "Utils/UrlUtils";

const AnonymousBankConnectionRankingDetailPage = () => {
  const { t } = useResource();
  const { bank } = useParams();

  const bankParam = bank as Bank;

  return (
    <AnonymousLayout title={t(Resources.BankRating.Title)}>
      <StyledPageWrapper>
        <Box mb={3}>
          <PageTitle
            title={t(Resources.BankRating.Title)}
            backNavigation={{
              mode: "historyStack",
              fallbackUrl: appUrl("bank-connection-ranking"),
            }}
          />
        </Box>
        <Box className="left-content">
          <PrimaryPaper>
            <BankRatingDetail bank={bankParam} />
          </PrimaryPaper>
        </Box>
      </StyledPageWrapper>
    </AnonymousLayout>
  );
};

export default AnonymousBankConnectionRankingDetailPage;
